<template>
  <div class="javaPage">
    <template v-if="from!='introDetail'">
      <div id="block"></div>
      <Header />
      <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <Box13 />
    <pageRightFloat pageName="JavaEE-就业课"/>
    <Footer />
    <div
      class="video-float"
      @click="play"
      :class="videoBtnShow ? 'show' : 'hidden'"
    >
      <div class="play-btn"></div>
      <div class="video-text">了解Java+AI</div>
    </div>
    <CourseVideo :src="src" :flag="flag" @close="close" specialStyle="1" pageName="JavaEE-就业课"></CourseVideo>
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";

import Box12 from "./Box12.vue";
import Box13 from "./Box13.vue";

import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
import CourseVideo from "../common/courseVideo.vue";
export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box12,
    Box13,
    pageRightFloat,
    Header,
    Footer,
    CourseVideo,
  },
  data() {
    return {
      flag: false,
      src: "",
      videoBtnShow: false,
      from:'',//来源
    };
  },
  mounted() {
   this.videoBtnShow = true
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    play() {
      this.mai("JavaEE-就业课","了解JavaEE",0,null)
      this.src = "https://file.boxuegu.com/bxgyingxiao/AI%E6%99%BA%E8%83%BD%E5%BA%94%E7%94%A8%E5%BC%80%E5%8F%91Java%EF%BC%88%E5%8A%A0logo%EF%BC%89.mp4";
      this.flag = true;
    },
    close() {
      this.src = "";
      this.flag = false;
    },
    zixun(name) {
      zhuge.track("H5_JAVAEE专题页", {
        咨询按钮名称: name,
      });
     this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
#block {
  width: 100%;
  height: 88px;
}
.show {
  width: 222px !important;
  .video-text {
    width: 100% !important;
  }
}
.video-float {
  transition: all 0.5s;
  position: fixed;
  right: 0;
  top: 136px;
  width: 10px;
  height: 64px;
  background: #ffffff
    linear-gradient(
      142deg,
      rgba(214, 222, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
  box-shadow: 0px 4px 24px -8px rgba(94, 123, 218, 0.4);
  border-radius: 200px 0px 0px 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 29;

  .play-btn {
    background: url("../../../assets/coursePage/java/javaPlay.png");
    width: 36px;
    height: 36px;
    background-size: cover;
    display: inline-block;
    flex-shrink: 0;
    margin: 0px 12px 0px 16px;
  }

  .video-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #273f6e;
    white-space: nowrap;

    width: 0;
    overflow: hidden;
  }
}
</style>
